// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__YbRu6","title":"ClientInsurance_title__30ASu","itemText":"ClientInsurance_itemText__3vw-1"};